function ZastitaZivotneSredine() {
  return <>ZastitaZivotneSredine</>;
}

export default ZastitaZivotneSredine;
